import { useCurrentUser } from '@/hooks/data/user';
import { Button, message, Modal, Spin } from 'antd';
import axios from 'axios';
import { useState } from 'react';

const CancelModalForm = (props) => {
   const subscription = props.subscription;
   const isTrial = subscription?.status === 'trialing';
   const accessEndsAt = subscription?.trialEndsAt || subscription?.nextBillDate;
   const [visible, setVisible] = useState(false);
   const [loading, setLoading] = useState(false);
   const { user } = useCurrentUser();
   const [messageApi, contextHolder] = message.useMessage();

   const buttonLabel = isTrial ? 'Cancel Trial' : 'Cancel Subscription';
   const modalTitle = isTrial ? 'Cancel Your Free Trial' : 'Cancel Your Subscription';
   const formattedAccessEnd = accessEndsAt
      ? new Date(accessEndsAt).toLocaleDateString('en-US', {
           year: 'numeric',
           month: 'long',
           day: 'numeric',
        })
      : null;
   const modalBody = isTrial
      ? `Cancel your free trial? You'll keep Pro access${
           formattedAccessEnd ? ` until ${formattedAccessEnd}` : ''
        } and won't be charged.`
      : 'Are you sure you want to cancel your subscription?';
   const successText = isTrial
      ? "Trial canceled — you won't be charged. You'll be redirected to a short survey."
      : 'Subscription canceled, you will be redirected to the survey shortly';

   const showModal = () => setVisible(true);
   const handleClose = () => setVisible(false);

   const handleCancel = async () => {
      setLoading(true);

      const response = await fetch('/api/subscription/cancel', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ subscription_id: subscription._id }),
      });

      if (!response.ok) {
         messageApi.error('Failed to cancel your subscription, please contact us');
         setLoading(false);
      } else {
         setLoading(false);
         setVisible(false);
         axios.post('https://n8n.premast.com/webhook/3f3a7104-70c2-4558-afe9-523744f8d9c1', {
            subscription_id: subscription._id,
            email: user.email,
            name: user.name,
            action: isTrial ? 'cancel_trial' : 'cancel',
            subscription: subscription,
         });

         messageApi.success(successText);
         setTimeout(() => {
            window.open('https://tally.so/r/mZZdje', '_blank');
         }, 1000);
      }
   };

   return (
      <>
         {contextHolder}
         <Button type="primary" onClick={showModal}>
            {buttonLabel}
         </Button>

         <Modal
            title={modalTitle}
            open={visible}
            onCancel={handleClose}
            width={500}
            footer={[
               <Button key="cancel" onClick={handleCancel} disabled={loading} variant="outlined" color="primary">
                  {buttonLabel}
               </Button>,
               <Button key="back" type="primary" onClick={handleClose}>
                  Keep {isTrial ? 'Trial' : 'Subscription'}
               </Button>,
            ]}
         >
            <p>{modalBody}</p>
            {loading && (
               <div style={{ textAlign: 'center', marginTop: 20 }}>
                  <Spin size="large" tip="Loading...">
                     <div style={{ padding: '28px 0px' }} />
                  </Spin>
               </div>
            )}
         </Modal>
      </>
   );
};

export default CancelModalForm;
